<template>
  <div class="vzan-address">
    <van-popup
      class="vzan-address-popup"
      id="vzanAddressPopup"
      :value="$attrs.show"
      round
      position="bottom"
      @click-overlay="handleClose"
      v-loading="loading"
    >
      <div class="line-model"></div>
      <div class="vzan-address-header" id="vzanAddressHeader">
        <p class="title">选择收货地址</p>
        <p class="sub-desc" v-if="!fromOrder">
          此奖品为寄送物品，请选择您的收货地址
        </p>
      </div>
      <div class="vzan-address-oper" id="vzanAddressFooter">
        <div class="address-button" @click="editAddress(0)">
          <img src="./img/location-icon.png" />
          <span>新增收货信息</span>
        </div>
        <div
          class="address-button"
          @click="getWxAddress"
          v-if="isWxMobile && !isMiniProgram && isShowWxGetAddress"
        >
          <img src="./img/wx-icon.png" />
          <span>获取微信地址</span>
        </div>
      </div>
      <div class="vzan-address-container" @scroll="handleScroll">
        <div
          class="vzan-address-item"
          v-for="item in list"
          :key="item.id"
          @click="chooseId = item.id"
        >
          <div class="vzan-address-item-content">
            <div class="main-info">
              <div class="name">{{ item.userName }}</div>
              <div class="phone">{{ item.telNumber }}</div>
            </div>
            <div class="sub-info">{{ item | getAddressDetail }}</div>
          </div>
          <div class="item-oper-group">
            <div class="item-radio active" v-if="item.id == chooseId">
              <img src="./img/checked-icon.png" />
              <span>选中</span>
            </div>
            <div class="item-radio" v-else>
              <img src="./img/no-check-icon.png" />
              <span>未选中</span>
            </div>
            <div class="item-oper-group">
              <div class="item-edit" @click.stop="editAddress(item.id)">
                <i class="iconfont iconbianji3"></i>
                <span>编辑</span>
              </div>
              <div class="item-edit" @click.stop="delAddress(item.id)">
                <i class="iconfont iconshanchu1"></i>
                <span>删除</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vzan-address-confirm-btn">
        <div class="btn" @click="sureChooseAddress">{{ btnText }}</div>
      </div>
    </van-popup>

    <!-- 新增 or 编辑收货信息 -->
    <van-popup
      class="vzan-address-popup vzan-address-editor-popup"
      id="vzanAddressPopup"
      v-model="iShowEditAddress"
      round
      position="bottom"
      @click-overlay="iShowEditAddress = false"
    >
      <div
        class="vzan-address-header vzan-address-editor-header"
        id="vzanAddressHeader"
      >
        <p class="title">填写收货信息</p>
        <p class="sub-desc" v-if="!fromOrder">
          此奖品为寄送物品，请输入您的物流地址
        </p>
      </div>
      <div class="vzan-address-editor-container">
        <div class="vzan-address-editor-item">
          <div class="label">姓名</div>
          <div class="vzan-address-item-content">
            <van-field
              v-model="detail.name"
              label=""
              placeholder="请输入姓名"
              maxlength="16"
            />
          </div>
        </div>
        <div class="vzan-address-editor-item">
          <div class="label">电话</div>
          <div class="vzan-address-item-content">
            <van-field
              v-model="detail.phone"
              type="digit"
              label=""
              placeholder="请输入手机号"
            />
          </div>
        </div>
        <div class="vzan-address-editor-item">
          <div class="label">地区</div>
          <div class="vzan-address-item-content" @click="iShowArea = true">
            <span class="text" v-if="detail.province"
              >{{ detail.province }} {{ detail.city }} {{ detail.county }}</span
            >
            <span class="text disabled" v-else>选择省/市/区</span>
            <img src="./img/right-arrow-icon.png" class="arrow-icon" />
          </div>
        </div>
        <div class="vzan-address-editor-item">
          <div class="label">详细地址</div>
          <div class="vzan-address-item-content">
            <van-field
              v-model="detail.addressDetail"
              label=""
              :maxlength="50"
              placeholder="街道门牌、楼层房间号等信息"
            />
          </div>
        </div>
        <div class="vzan-address-editor-item">
          <div class="label">邮政编码</div>
          <div class="vzan-address-item-content">
            <van-field
              v-model="detail.areaCode"
              type="digit"
              label=""
              placeholder="请输入邮政编码"
            />
          </div>
        </div>
        <div class="vzan-address-editor-item hauto">
          <div class="vzan-address-item-content">
            <AddressParse @ok="handleParseAddressOK" />
          </div>
        </div>
        <br />
      </div>
      <div class="vzan-address-editor-footer">
        <div class="editor-button cancel-btn" @click="iShowEditAddress = false">
          取消
        </div>
        <div class="editor-button sure-btn" @click="saveAddress">保存</div>
      </div>
    </van-popup>

    <!-- 省市区选择框 -->
    <!-- 地址 -->
    <van-action-sheet
      v-model="iShowArea"
      close-on-click-action
      @close="cancelAddressSelect"
    >
      <van-area
        title="请选择所在地区"
        :area-list="areaList"
        @cancel="cancelAddressSelect"
        @confirm="confirmAddressSelect"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from 'vue'
import $api from './api'
import { areaList } from '@vant/area-data'
import { isWx, isMiniApp } from '@/utils/utils'

// 保存地址校验方法
const validateDetailFn = {
  name: {
    fn(value) {
      if (!value.trim().length) {
        Vue.prototype.$toast('请输入姓名')
        return false
      }
      if (value.trim().length > 16) {
        Vue.prototype.$toast('收货人姓名不能超过16个字')
        return false
      }
      return true
    },
  },
  phone: {
    fn(value) {
      if (!value.trim().length) {
        Vue.prototype.$toast('请输入电话')
        return false
      }
      if (!/^\d{11}$/.test(value)) {
        Vue.prototype.$toast('请输入11位联系电话')
        return false
      }
      return true
    },
  },
  province: {
    fn(value) {
      if (!value.trim().length) {
        Vue.prototype.$toast('请选择下地区')
        return false
      }
      return true
    },
  },
  addressDetail: {
    fn(value) {
      if (!value.trim().length) {
        Vue.prototype.$toast('请输入详细地址')
        return false
      }
      return true
    },
  },
}
export default {
  name: 'VzanAddressNew',
  components: {
    AddressParse: () =>
      import(
        /* webpackChunkName: "AddressParse" */ '@/components/global/AddressParse.vue'
      ),
  },
  props: {
    showDefault: {
      // 是否显示默认地址
      type: Boolean,
      default: true,
    },
    fromOrder: {
      // 来自订单的修改
      type: Boolean,
      default: false,
    },
    btnText: {
      // 底部按钮文案
      type: String,
      default: '立即兑换',
    },
    // 代理页面跳转过来的
    isAgentAndAgentPage: {
      type: [Boolean, Number],
      default: false,
    },
    takeOrderUserId: {
      type: String,
      default: '',
    },
    isShowWxGetAddress: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'show',
    event: 'show',
  },
  data() {
    return {
      loading: false,
      page: 1,
      size: 10,
      loaded: false,
      list: [],
      chooseId: 0,
      adressId: 0,
      iShowEditAddress: false, // 新增编辑弹框
      text: '',

      cascaderValue: '',
      areaList,
      detail: {}, // 地址对象信息
      iShowArea: false,
      isWxMobile: isWx('mobile'),
    }
  },
  computed: {
    // ...mapState(['isMiniProgram']),
    isMiniProgram() {
      return isMiniApp()
    },
  },
  watch: {
    '$attrs.show': {
      handler(show) {
        show && this.init()
      },
    },
  },
  filters: {
    getAddressDetail(item) {
      const { cityName, detailInfo, provinceName, townName } = item
      return provinceName + cityName + townName + detailInfo
    },
  },
  methods: {
    async init() {
      await this.address(true)
      if (this.showDefault) {
        this.list.length && this.default_address()
      }
    },
    getIsAgentAndAgentPage(data) {
      const zbid = Number(this.$route.query.zbId || this.$route.query.zbid)
      const status = Boolean(this.isAgentAndAgentPage) && this.takeOrderUserId
      let params = {}
      if (zbid > 0) {
        params = status
          ? {
              ...data,
              zbid,
              isAgentTakeOrder: true,
              takeOrderUserId: Number(this.takeOrderUserId),
            }
          : { ...data, zbid }
      } else {
        params = data
      }
      return params
    },
    // 获取所有地址列表
    async address(reset = false) {
      try {
        if (reset) {
          this.page = 1
          this.list = []
          this.loading = false
          this.loaded = false
        }
        if (this.loading || this.loaded) return
        this.loading = true
        const commentParams = { page: this.page, size: this.size }
        const params = this.getIsAgentAndAgentPage(commentParams)
        const res = await $api.address(params)
        this.list = [...this.list, ...res.dataObj]
        this.loaded = res.dataObj.length < this.size
        if (!this.loaded) {
          this.page++
        }
      } catch (error) {
        this.$toast(typeof error === 'string' ? error : '获取地址异常')
      } finally {
        this.loading = false
      }
    },
    // 初始化勾选的地址
    async default_address() {
      try {
        const res = await $api.default_address({})
        this.chooseId = res.dataObj && res.dataObj.id
      } catch (error) {
        console.log(error)
      }
    },
    // 新增或编辑地址
    async editAddress(id) {
      this.adressId = id
      this.detail = {
        id: 0,
        name: '',
        phone: '',
        province: '',
        city: '',
        county: '',
        addressDetail: '',
        areaCode: '',
        isDefault: false,
      }
      if (id) {
        try {
          const params = this.getIsAgentAndAgentPage({ id })
          const res = await $api.address(params)
          if (res && res.dataObj) {
            this.detail = {
              id: res.dataObj.id,
              name: res.dataObj.userName,
              phone: res.dataObj.telNumber,
              province: res.dataObj.provinceName,
              city: res.dataObj.cityName,
              county: res.dataObj.townName,
              addressDetail: res.dataObj.detailInfo,
              areaCode: res.dataObj.cityCode,
              isDefault: res.dataObj.isDefault,
            }
          }
        } catch (error) {
          this.$toast(typeof error === 'string' ? error : '获取地址异常')
        }
      }
      this.iShowEditAddress = true
    },
    // 调用微信选择地址列表
    getWxAddress() {
      let that = this
      wx.openAddress({
        success: function (res) {
          console.log('地址', res)
          that.detail['id'] = 0
          that.detail.name = res.userName
          that.detail.phone = res.telNumber
          that.detail.province = res.provinceName
          that.detail.city = res.cityName
          that.detail.county = res.countryName
          that.detail.addressDetail = res.detailInfo
          that.detail.areaCode = res.postalCode
          that.detail.isDefault = false
          that.saveAddress()
        },
      })
    },
    // 删除地址
    async delAddress(id) {
      await this.$dialog.confirm({ message: '确定删除该收货地址吗' })
      try {
        const params = this.getIsAgentAndAgentPage({ id })
        const res = await $api.del_address(params)
        this.$toast(res.msg || '已移除')
        this.init()
      } catch (error) {
        this.$toast(typeof error === 'string' ? error : '删除地址异常')
      }
    },
    // 确认选择省市区
    confirmAddressSelect(e) {
      console.log(e)
      this.detail.province = e[0].name
      this.detail.city = e[1].name
      this.detail.county = e[2].name
      this.cancelAddressSelect()
    },
    // 取消选择
    cancelAddressSelect() {
      this.iShowArea = false
    },
    // 保存地址
    async saveAddress() {
      try {
        if (!Object.keys(this.detail).length) return
        for (let key in this.detail) {
          if (
            ['name', 'phone', 'province', 'addressDetail'].includes(key) &&
            !validateDetailFn[key].fn(this.detail[key])
          ) {
            return
          }
        }
        console.log('hhhhh')
        const params = {
          Id: this.detail.id || 0,
          UserName: this.detail.name,
          TelNumber: this.detail.phone,
          DetailInfo: this.detail.addressDetail,
          ProvinceName: this.detail.province,
          CityName: this.detail.city,
          TownName: this.detail.county,
          CityCode: this.detail.areaCode || '',
          IsDefault: this.detail.isDefault,
        }
        const newParams = this.getIsAgentAndAgentPage(params)
        const res = await $api.save_address(newParams)
        this.$toast(res.msg || '保存成功')
        this.iShowEditAddress = false
        this.init()
      } catch (error) {
        this.$toast(typeof error === 'string' ? error : '保存地址异常')
      }
    },
    handleClose() {
      this.$emit('show', false)
      if (!this.showDefault) {
        this.chooseId = 0
      }
    },
    // 确认选择地址
    sureChooseAddress() {
      if (!this.list.length) return this.$toast('请先添加地址')
      let info =
        (this.list.length &&
          this.list.find(item => item.id == this.chooseId)) ||
        {}
      if (info && !Object.keys(info).length) return this.$toast('请先选择地址')
      if (!info.detailInfo || !info.cityName) {
        return this.$toast('请完善收货地址')
      }

      this.$emit('ok', info)
      this.handleClose()
    },
    handleParseAddressOK(res) {
      if (res) {
        let that = this
        that.detail.name = res.name || that.detail.name
        that.detail.phone = res.phone || that.detail.phone
        that.detail.province = res.province || that.detail.province
        that.detail.city = res.city || that.detail.city
        that.detail.county = res.county || that.detail.county
        that.detail.addressDetail = res.address || that.detail.addressDetail
        that.detail.areaCode = res.cityCode
      }
    },
    handleScroll(e) {
      // console.log('e,', e)
      const target = e.target
      if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
        if (!this.loading && !this.loaded) {
          console.log('触发触底加载')
          this.address()
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.vzan-address-popup {
  overflow: visible;
  background: linear-gradient(360deg, #f6f6f8 0%, #ffffff 100%, #ffeeea 100%);
  height: 495px;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 361px;
    background: url(./img/address-bg.png) no-repeat center top;
    background-size: cover;
  }
  .line-model {
    position: absolute;
    left: 50%;
    top: -13px;
    transform: translateX(-50%);
    width: 38px;
    height: 5px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 3px;
  }
  &.vzan-address-editor-popup {
    height: 470px;
    background: #fff;
    &::before {
      display: none;
    }
  }
}
.vzan-address-header {
  position: relative;
  box-sizing: border-box;
  padding: 20px 0 14px;
  text-align: center;
  .title {
    color: #202124;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .sub-desc {
    color: #919499;
    font-size: 12px;
  }
  &.vzan-address-editor-header {
    padding: 19px 0 0;
  }
}
.vzan-address-oper {
  position: relative;
  width: 100%;
  padding: 0 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .address-button {
    flex: 1;
    height: 60px;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    color: #202124;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    &:not(:last-of-type) {
      margin-right: 9px;
    }
    img {
      width: 18px;
      margin-right: 10px;
    }
  }
}
.vzan-address-container {
  position: relative;
  padding: 0 8px 12px;
  padding-bottom: calc(98px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  height: calc(100% - (128px + env(safe-area-inset-bottom)));
  margin-top: 12px;
  overflow: hidden auto;
  .vzan-address-item {
    padding: 0 16px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 12px;
    &:not(:last-of-type) {
      margin-bottom: 12px;
    }
    .vzan-address-item-content {
      flex: 1;
      padding: 18px 0;
      border-bottom: 1px solid #edeff2;
      .main-info {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 13px;
        color: #60646b;
        margin-bottom: 5px;
        .name {
          color: #202124;
          font-size: 16px;
          font-weight: bold;
          margin-right: 12px;
          margin-bottom: 5px;
        }
        .phone {
          margin-bottom: 5px;
        }
      }
      .sub-info {
        font-size: 13px;
        font-weight: 400;
        color: #202124;
        line-height: 20px;
      }
    }
    .item-oper-group {
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item-radio {
        color: #b8babf;
        font-size: 12px;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          margin-right: 6px;
          margin-top: -1px;
        }
        &.active {
          color: #ff4444;
        }
      }
    }
    .item-oper-group {
      display: flex;
      align-items: center;
    }
    .item-edit {
      font-size: 12px;
      color: #919499;
      display: flex;
      align-items: center;
      margin-left: 16px;
      .iconfont {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}
.vzan-address-confirm-btn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  padding: 12px 16px;
  box-sizing: border-box;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  .btn {
    height: 50px;
    font-size: 14px;
    color: #fff;
    background: linear-gradient(270deg, #ff5625 0%, #ff4444 100%);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
// 新增或编辑地址
.vzan-address-editor-container {
  position: relative;
  padding: 0 16px 82px;
  box-sizing: border-box;
  height: calc(100% - (65px + env(safe-area-inset-bottom)));
  margin-top: 12px;
  overflow: hidden auto;
  .vzan-address-editor-item {
    height: 62px;
    border-bottom: 1px solid #edeff2;
    display: flex;
    align-items: center;
    .label {
      flex-shrink: 0;
      min-width: 60px;
      color: #60646b;
      font-size: 14px;
      margin-right: 15px;
    }
    .vzan-address-item-content {
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      .text {
        flex: 1;
        overflow: hidden;
        &.disabled {
          color: #c8c9cc;
        }
      }
      .van-cell {
        padding: 10px 0;
        &::after {
          display: none;
        }
      }
      ::v-deep {
        .van-field__control:disabled {
          background: transparent;
        }
      }
      .arrow-icon {
        width: 18px;
        height: 18px;
        margin-left: 15px;
        margin-right: 5px;
      }
    }
  }
}
.vzan-address-editor-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  padding: 20px 16px 16px;
  box-sizing: border-box;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  display: flex;
  justify-content: space-between;
  align-items: center;
  .editor-button {
    width: 166px;
    height: 50px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    &.cancel-btn {
      color: #550c16;
      background: #fff1f1;
    }
    &.sure-btn {
      color: #fff;
      background: linear-gradient(270deg, #ff5625 0%, #ff4444 100%);
    }
  }
}
</style>
